<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8N2nA6/tc-custom/9781627793803.jpg?1730981752638" alt="This image is the cover for the book Some Possible Solutions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Some Possible Solutions
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In a spine-tingling new collection, the “unique”(NPR) and “wickedly funny” (New York Times) Helen Phillips offers an idiosyncratic series of “what-ifs” about our fragile human condition.</b><br/><br/><i>Some Possible Solutions</i> offers an idiosyncratic series of "What ifs": What if your perfect hermaphrodite match existed on another planet? What if you could suddenly see through everybody's skin to their organs? What if you knew the exact date of your death? What if your city was filled with doppelgangers of you? <br/><br/> Forced to navigate these bizarre scenarios, Phillips' characters search for solutions to the problem of how to survive in an irrational, infinitely strange world. In dystopias that are exaggerated versions of the world in which we live, these characters strive for intimacy and struggle to resolve their fraught relationships with each other, with themselves, and with their place in the natural world. We meet a wealthy woman who purchases a high-tech sex toy in the shape of a man, a rowdy, moody crew of college students who resolve the energy crisis, and orphaned twin sisters who work as futuristic strippers--and with Phillips' characteristic smarts and imagination, we see that no one is quite who they appear.<br/><br/> By turns surreal, witty, and perplexing, these marvelous stories are ultimately a reflection of our own reality and of the big questions that we all face. Who are we? Where do we fit? Phillips is a true original and a treasure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Phillips
      </h2>
      
      <p class="authorDescription body article"><B>Helen Phillips </B>is the recipient of a Rona Jaffe Foundation Writer's Award and the Italo Calvino Prize and more. She is the author of the widely acclaimed<I> The Beautiful Bureaucrat</I>. Her debut collection <I>And Yet They Were Happy</I> was named a notable book by The Story Prize. Her work has appeared in <I>Tin House</I>, <I>Electric Literature</I>, and <I>The New York Times</I>. An assistant professor of creative writing at Brooklyn College, she lives in Brooklyn with her husband and children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bb1cc2e